import React from 'react';
import { colors } from '../../styles/styles';

/**
 * Reusable action button component with icon and text
 */
const ActionButton = ({
  onClick,
  icon,
  text,
  color = colors.accent.white,
  backgroundColor = 'transparent',
  style = {},
  iconPosition = 'left',
  gap = 4,
  padding = '4px 8px',
  fontSize = 14,
  fontWeight = 'bold'
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        backgroundColor,
        color,
        border: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: `${gap}px`,
        padding,
        fontSize: `${fontSize}px`,
        fontWeight,
        cursor: 'pointer',
        flexDirection: iconPosition === 'left' ? 'row' : 'row-reverse',
        ...style
      }}
    >
      {icon}
      {text}
    </button>
  );
};

export default ActionButton; 